<template>
    <div class="flex flex-col gap-2 w-full">
        <UAlert
            v-if="missingSubAccounts && missingSubAccounts > 0"
            color="error"
            variant="subtle"
            :title="`${props.isCustomer ? 'Kunder' : 'Leverandører'} mangler i systemet (${missingSubAccounts})`"
            icon="i-ph-warning-circle"
            orientation="horizontal"
            :actions="[
                {
                    label: `Opprett ${props.isCustomer ? 'kunde' : 'leverandør'} (${missingSubAccounts})`,
                    color: 'neutral',
                    class: 'border border-base-content text-base-content shadow-none ring-0',
                    variant: 'outline',
                    onClick: fixAllMissingSubAccounts
                }
            ]"
            :ui="{
                root: 'p-2',
                icon: 'size-6',
            }"
        />
        <UAlert
            v-if="misnamedSubAccounts && misnamedSubAccounts > 0"
            color="warning"
            variant="subtle"
            :title="`${props.isCustomer ? 'Kunder' : 'Leverandører'} har avvikende navn mot system (${misnamedSubAccounts})`"
            icon="i-ph-warning"
            orientation="horizontal"
            :actions="[
                {
                    label: `Endre navn (${misnamedSubAccounts})`,
                    color: 'neutral',
                    class: 'border border-base-content text-base-content shadow-none ring-0',
                    variant: 'outline',
                    onClick: correctMisnamedSubAccounts
                }
            ]"
            :ui="{
                root: 'p-2',
                icon: 'size-6',
            }"
        />
        <UAlert
            v-if="inactiveSubAccounts && inactiveSubAccounts > 0"
            color="warning"
            variant="subtle"
            :title="`${props.isCustomer ? 'Kunder' : 'Leverandører'} er inaktiv (${inactiveSubAccounts})`"
            icon="i-ph-warning"
            orientation="horizontal"
            :actions="[
                {
                    label: `Aktiver (${inactiveSubAccounts})`,
                    color: 'neutral',
                    class: 'border border-base-content text-base-content shadow-none ring-0',
                    variant: 'outline',
                    onClick: activateAllInactiveSubAccounts
                }
            ]"
            :ui="{
                root: 'p-2',
                icon: 'size-6',
            }"
        />
        <UAlert
            v-if="duplicatedInvoiceNos && duplicatedInvoiceNos > 0"
            color="error"
            variant="subtle"
            :title="`Duplikate fakturanr (${duplicatedInvoiceNos})`"
            icon="i-ph-warning-circle"
            orientation="horizontal"
            :ui="{
                root: 'p-2',
                icon: 'size-6',
            }"
        />
        <UAlert
            v-if="missingDueDates && missingDueDates > 0"
            color="error"
            variant="subtle"
            :title="`Mangler forfallsdato (${missingDueDates})`"
            icon="i-ph-warning-circle"
            orientation="horizontal"
            :ui="{
                root: 'p-2',
                icon: 'size-6',
            }"
        />
    </div>
</template>

<script setup lang="ts">

import subAccountComposable from '@/incoming-balance/subaccount.composable'
import {computed} from 'vue'

const {useCustomerBalance, useSupplierBalance} = subAccountComposable()
const {deviations: customerDeviations, createMissingSubAccounts: fixAllMissingCustomerAccounts, correctMisnamedSubAccounts: correctMisnamedCustomers, activateAllInactiveSubAccounts: activateCustomers} = useCustomerBalance()
const {deviations: supplierDeviations, createMissingSubAccounts: fixAllMissingSupplierAccounts, correctMisnamedSubAccounts: correctMisnamedSuppliers, activateAllInactiveSubAccounts: activateSuppliers} = useSupplierBalance()

const props = defineProps({
    isCustomer: {
        type: Boolean,
        required: true
    }
})

const fixAllMissingSubAccounts = props.isCustomer ? fixAllMissingCustomerAccounts : fixAllMissingSupplierAccounts
const correctMisnamedSubAccounts = props.isCustomer ?  correctMisnamedCustomers : correctMisnamedSuppliers
const activateAllInactiveSubAccounts = props.isCustomer ? activateCustomers : activateSuppliers

const {missingSubAccounts, misnamedSubAccounts, inactiveSubAccounts, duplicatedInvoiceNos, missingDueDates} = computed(() => props.isCustomer ? customerDeviations : supplierDeviations).value


</script>

<style scoped>

</style>